export default {
  // 对话框标题
  title: "添加标签",

  // 表单相关
  pleaseSelect: "请选择",
  pleaseInput: "请输入",
  pleaseInputContent: "请输入内容",

  // 按钮
  cancel: "取 消",
  confirm: "确 定",

  // 验证消息
  requiredFieldError: "*号为必填项",
  addLabelSuccess: "此数据已成功打上该标签",
};
